import { CaretRight } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import { Drawer, DrawerContent } from "common/components/ui/Drawer";

import TokenDetails from "./TokenDetails";

import type { ApiToken } from "../../../types";

interface MobileListProps {
  tokens: ApiToken[];
  onDelete: (apiToken: ApiToken) => void;
}

export default function MobileList({ tokens, onDelete }: MobileListProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedToken, setSelectedToken] = useState<ApiToken>(null);

  const handleDrawerState = (isOpen: boolean) => {
    setIsDrawerOpen(isOpen);
  };

  const handleRowClick = (apiToken: ApiToken) => {
    setSelectedToken(apiToken);
    setIsDrawerOpen(true);
  };

  const handleDelete = () => {
    setIsDrawerOpen(false);
    onDelete(selectedToken);
  };

  return (
    <div className="flex flex-col gap-y-2">
      <div className="grid grid-cols-3 rounded-2xl bg-black-100 px-4 py-2">
        <span className="text-xs">Key name</span>
        <span className="text-center text-xs">Permission</span>
      </div>

      <div className="flex flex-col gap-2">
        {tokens.map((apiKey) => {
          const { id, name, read: canRead, write: canWrite } = apiKey;
          const permissions = canRead && canWrite ? "All" : "Read only";

          return (
            <button
              key={id}
              type="button"
              className="grid grid-cols-3 items-center gap-4 rounded-3xl border border-black-200 p-3"
              onClick={() => handleRowClick(apiKey)}
            >
              {/* Token name */}
              <span className="line-clamp-1 break-words text-start text-lg-bold">
                {name}
              </span>

              {/* Permissions */}
              <span className="capitalize text-black-700">{permissions}</span>

              {/* Action button */}
              <Button
                asChild
                className="ml-auto"
                intent="labelIcon"
                variant="ghost-black"
              >
                <CaretRight />
              </Button>
            </button>
          );
        })}
      </div>

      {/* Selected token details & preview */}
      <Drawer open={isDrawerOpen} onOpenChange={handleDrawerState}>
        <DrawerContent>
          <TokenDetails
            selectedToken={selectedToken}
            onDelete={handleDelete}
            onClose={() => setIsDrawerOpen(false)}
          />
        </DrawerContent>
      </Drawer>
    </div>
  );
}
